// extracted by mini-css-extract-plugin
export default {"articleMain":"SectionArticle_articleMain__Xiu1S","noSidePaddings":"SectionArticle_noSidePaddings__mgMyQ","blockContainerScroll":"SectionArticle_blockContainerScroll__Rh2j0"};